module.exports = __webpack_public_path__ + "img/close.edbc5fb2.svg";